import axios from "axios";
import { getAuthHeader } from "@/services/user.service.js";

export { GetAllNogaBranches };

function GetAllNogaBranches(onSuccess, onError) {
  const headers = getAuthHeader();

  axios
    .get(process.env.VUE_APP_BASE_API_URL + "/branches/noga", headers)
    .then((response) => {
      onSuccess(response.data);
    })
    .catch((error) => {
      onError(error);
    });
}
